<template>
    <home-corporate v-if="onCorporate()"></home-corporate>
    <home-group v-else></home-group>
</template>

<script setup>
import HomeCorporate from './HomeCorporate.vue'
import HomeGroup from './HomeGroup.vue'
import { useCurrentGroup } from '~/composables/useCurrentGroup';

const { onCorporate } = useCurrentGroup();
</script>
